/**
 * @module geo/actions/creators
 */

import { REGISTER_EXTENSION } from "../../payload/facade/REGISTER_EXTENSION";
import { actionCreatorsBuilder } from "../helpers/actions.creator.builder";
import { TypeKeyActions } from "../types.key.action";
import {Acknowledged} from '../../payload/response/acknowledged';

export const [
  /**
   * return an action to register an extension in the GeoApp
   * @type {ActionCreator<REGISTER_EXTENSION>}
   * @since 2.1.0
   */
  registerExtensionCreator,
  /**
   * return an action to registerExtension
   * @type {AsyncActionCreators<REGISTER_EXTENSION,Acknowledged, Error>}
   * @since 2.1.0
   */
  registerExtensionAsyncCreator,
  /**
   * return an async action to register an extension in the GeoApp
   * parameters
   * @type {Promise}
   * @since 2.1.0
   * @private
   * @hidden
   */
  registerExtensionCreatorP
] = actionCreatorsBuilder<REGISTER_EXTENSION, Acknowledged, Error>(
  TypeKeyActions.REGISTER_EXTENSION
);
